module.exports = __webpack_public_path__ + "static/media/475GriffinStNW_2018-06-05_26.3bf4b122.jpg";